export function estoqueTanquesInRequest(params = {}) {
  return {
    type: '@operacaoestoquetanque/ESTOQUETANQUES_IN_REQUEST',
    payload: { params },
  };
}

export function findEstoqueTanque(id) {
  return {
    type: '@operacaoestoquetanque/FIND_ESTOQUETANQUE',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoestoquetanque/FAILED_REQUEST',
  };
}

export function deleteEstoqueTanque(id, params) {
  return {
    type: '@operacaoestoquetanque/DELETE_ESTOQUETANQUE',
    payload: { id, params },
  };
}

export function updateEstoqueTanque(data, params) {
  return {
    type: '@operacaoestoquetanque/UPDATE_ESTOQUETANQUE',
    payload: { data, params },
  };
}

export function storeEstoqueTanque(data, params) {
  return {
    type: '@operacaoestoquetanque/STORE_ESTOQUETANQUE',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@operacaoestoquetanque/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@operacaoestoquetanque/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoestoquetanque/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoestoquetanque/RECORD_FILTERING',
    payload: { params },
  };
}

export function resetFiltering(params = {}) {
  return {
    type: '@operacaoestoquetanque/RESET_FILTERING',
    payload: { params },
  };
}
